var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#17bae0;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M35.975,11.988a4.988,4.988,0,1,0-4.988,4.988A5,5,0,0,0,35.975,11.988Z",
    transform: "translate(-21.919 -7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.041,54.67a6.287,6.287,0,0,1-3.945,0,5.07,5.07,0,0,0-5.532,1.5A6.985,6.985,0,0,0,8,60.564a1.674,1.674,0,0,0,1.678,1.678H24.459a1.674,1.674,0,0,0,1.678-1.678,6.985,6.985,0,0,0-1.564-4.4A5.08,5.08,0,0,0,19.041,54.67Z",
    transform: "translate(-8 -43.652)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson24Px);
export default __webpack_public_path__ + "static/media/person-24px.cf9ac93f281a369a290c17880c3e398b.svg";
export { ForwardRef as ReactComponent };